import { apiClient } from "../../api/client";

export interface UserItem {
  id: string;
  name: string;
  email?: string;
}

export interface UserDetailResponse {
  id: string;
  firstName?: string;
  lastName?: string;
  emailId?: string;
  phone?: string;
}

export interface UsersListResponse {
  message?: string;
  data?: UserItem[];
  // Some APIs may return the array directly
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface MemberListResponse {
  message?: string;
  data?: UserDetailResponse[];
  // Some APIs may return the array directly
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}



export async function fetchUsers(): Promise<UserItem[]> {
  const res = await apiClient.get<UsersListResponse>(`/userlist`);
  const body = res?.data;
  if (Array.isArray(body)) return body as unknown as UserItem[];
  if (Array.isArray(body?.data)) return body.data as UserItem[];
  return [];
}

export async function fetchMembers(): Promise<UserDetailResponse[]> {
  const res = await apiClient.get<MemberListResponse>(`/user/get-members`);
  const body = res?.data;
  if (Array.isArray(body)) return body as unknown as UserDetailResponse[];
  if (Array.isArray(body?.data)) return body.data as UserDetailResponse[];
  return [];
}

export interface AssignHtmlRequest {
  userEmail: string; // selected member's email
  htmlId: string;    // template html/file id
}

export interface AssignHtmlResponse {
  message?: string;
}

export async function assignHtmlToUser(payload: AssignHtmlRequest): Promise<AssignHtmlResponse> {
  const res = await apiClient.post<AssignHtmlResponse>(`/user/assign-html`, payload);
  return res?.data ?? { message: "Assigned" };
}

export interface SaveMemberPayload {
  emailId: string;
  memberId: string;
  htmlId: string;
}

export interface SaveMemberResponse {
  message: string;
}

export async function saveMember(payload: SaveMemberPayload): Promise<SaveMemberResponse> {
  try {
    const res = await apiClient.post<SaveMemberResponse>(`/user/save-member`, payload);
    return res?.data ?? { message: "Member saved" };
  } catch (error) {
    console.error("Error saving member:", error);
    throw error;
  }
}
